import React from "react";
import { IconContainer } from "./IconContainer";

export const MinusIcon = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.20312 7.99844C3.20312 7.66707 3.47175 7.39844 3.80313 7.39844L12.2031 7.39844C12.5345 7.39844 12.8031 7.66707 12.8031 7.99844C12.8031 8.32981 12.5345 8.59844 12.2031 8.59844L3.80313 8.59844C3.47175 8.59844 3.20312 8.32981 3.20312 7.99844Z"
      fill="currentColor"
    />
  </IconContainer>
);
